import {
    AfterContentInit,
    Component,
    ContentChildren,
    EventEmitter,
    Input,
    OnInit,
    OnChanges,
    OnDestroy,
    Output,
    QueryList,
    SimpleChanges
} from '@angular/core';

import { NgRedux, select } from '@angular-redux/store';
import { Subscription } from 'rxjs';

import { UiDropdownId } from '../../../../interfaces/ui.interface';
import { AppState } from '../../../../interfaces/store.interface';

import { SortOptionComponent } from '../sort-option/sort-option.component';
import { UiActionsService } from '../../../store/actions/ui.actions';

interface SortOption {
    label: string;
    value: string;
}

@Component({
    selector: 'app-sort',
    templateUrl: './sort.component.html',
    styleUrls: ['./sort.component.scss']
})
export class SortComponent implements OnInit, OnChanges, OnDestroy, AfterContentInit {

    @Input() sortColumn: string;
    @Input() sortMode: boolean;

    sortLabel: string;

    visible: boolean;

    @Output() change = new EventEmitter();

    @ContentChildren(SortOptionComponent) sortOptions: QueryList<SortOptionComponent>;

    options: SortOption[] = [];

    private dropdownId: UiDropdownId = 'SORT';

    private uiSubscription = Subscription.EMPTY;

    constructor(private uiActions: UiActionsService, private ngRedux: NgRedux<AppState>) { }

    ngOnInit() {
        // track the UI
        this.uiSubscription = this.ngRedux.select<UiDropdownId>(['ui', 'dropdown', 'id'])
            .subscribe((id: UiDropdownId) => {
                this.visible = id === this.dropdownId;
            });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['sortColumn']) {
            this.readLabelFromOptions();
        }
    }

    ngOnDestroy() {
        this.uiSubscription.unsubscribe();
    }

    ngAfterContentInit() {

        this.options = this.sortOptions.map((opt: SortOptionComponent) => {
            return {
                label: opt.label,
                value: opt.value
            };
        });

        this.readLabelFromOptions();

    }

    toggleSortDropdown(event: Event) {
        event.stopPropagation();

        this.uiActions.toggleDropdown({
            id: this.dropdownId
        });
    }

    setSort(event: Event, option: SortOption, sortMode: boolean) {

        this.sortLabel = option.label;

        if (this.sortColumn === option.value && this.sortMode === sortMode) {
            this.change.emit({
                value: {
                    sortColumn: null,
                    sortMode: null
                }
            });
            return;
        }

        this.change.emit({
            value: {
                sortColumn: option.value,
                sortMode
            }
        });

    }

    private readLabelFromOptions() {

        this.sortLabel = null;

        const options = this.options.filter((option => {
            return option.value === this.sortColumn;
        }));

        if (options.length) {
            this.sortLabel = options[0].label;
        }

    }

}
